import { qs, qsa, add, listen } from "@fluorescent/dom";

const { icons } = window.theme;

const classes = {
  activeThumbnail: "pswp__thumbnail--active",
};

export default function productLightbox() {
  const lightboxImages = qsa(".lightbox-image", document);
  if (!lightboxImages.length) return;

  const zoomThumbnailsEnabled = qs(
    "[data-zoom-gallery-has-thumbnails]",
    document
  )?.dataset.zoomGalleryHasThumbnails;

  let productLightbox;

  import(flu.chunks.photoswipe).then(({ PhotoSwipeLightbox, PhotoSwipe }) => {
    productLightbox = new PhotoSwipeLightbox({
      gallery: ".lightbox-media-container",
      children: ".lightbox-image",
      showHideAnimationType: "zoom",
      pswpModule: PhotoSwipe,
      mainClass: "pswp--product-lightbox",
      bgOpacity: 1,
      arrowPrevSVG: icons.chevron,
      arrowNextSVG: icons.chevron,
      closeSVG: icons.close,
      zoomSVG: icons.zoom,
      ...(zoomThumbnailsEnabled === "true" && {
        paddingFn: viewportSize => {
          return {
            bottom: viewportSize.x < 720 ? 80 : 94,
          };
        },
      }),
    });

    productLightbox.init();

    if (window.Shopify?.designMode) {
      listen(document, "shopify:section:load", () => {
        // Re-init lightbox after theme editor re-render to allow it to keep working
        productLightbox.init();
      });
    }

    // Hide nav ui elements if single image
    productLightbox.on("firstUpdate", () => {
      const { pswp, options } = productLightbox;
      const productImageCount = options.dataSource.items.length;

      if (productImageCount === 1) {
        add(pswp.element, "pswp--is-single-image");
      }
    });

    // Render thumbnails if enabled
    if (zoomThumbnailsEnabled === "true") {
      productLightbox.on("uiRegister", () => {
        productLightbox.pswp.ui.registerElement({
          name: "thumbnails",
          appendTo: "root",
          html: '<div class="pswp__thumbnails-inner"></div>',
          onInit: (el, pswp) => {
            const { options } = productLightbox;
            const thumbnails = [];
            const thumbnailsInner = qs(".pswp__thumbnails-inner", el);
            const images = options.dataSource.items.map(item =>
              qs(".image", item)
            );
            let prevIndex = -1;

            images.forEach((image, index) => {
              const thumbnail = document.createElement("div");
              thumbnail.className = "pswp__thumbnail";
              thumbnail.appendChild(image.cloneNode(true));
              thumbnail.querySelector("img").setAttribute("sizes", "70px");
              thumbnail.onclick = () => {
                pswp.goTo(index);
              };
              thumbnailsInner.appendChild(thumbnail);
              thumbnails.push(thumbnail);
            });

            add(pswp.element, "pswp--has-thumbnails");

            pswp.on("change", () => {
              if (prevIndex >= 0) {
                thumbnails[prevIndex].classList.remove(classes.activeThumbnail);
              }
              thumbnails[pswp.currIndex].classList.add(classes.activeThumbnail);
              thumbnails[pswp.currIndex].scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center",
              });
              prevIndex = pswp.currIndex;
            });
          },
        });
      });

      // Isolate wheel event to scrollWrap (allows thumbnails to scroll)
      productLightbox.on("afterInit", () => {
        const { element, events, scrollWrap } = productLightbox.pswp;
        const wheelEventIndex = events._pool.findIndex(
          event => event.type === "wheel"
        );

        // Abort if no wheel event in Photoswipe
        if (wheelEventIndex === -1) {
          return;
        }

        const wheelEvent = events._pool[wheelEventIndex].listener;
        element.removeEventListener("wheel", wheelEvent);
        scrollWrap.addEventListener("wheel", wheelEvent);
      });
    }
  });
}
